<template>
  <!-- Confirmation of a destructive action in place of its button: browser dialogs (window.confirm)
       are blocked or closed at once in some embeddings, so deletions never happened there. -->
  <span
    class="ai-confirm"
    role="group"
    :aria-label="text"
    @keydown.esc.stop.prevent="$emit('cancel')"
  >
    <span class="ai-confirm__text">{{ text }}</span>
    <span class="ai-confirm__buttons">
      <button
        type="button"
        class="ai-button is-small is-danger"
        :disabled="busy"
        @click="$emit('confirm')"
      >
        <span
          v-if="busy"
          class="ai-spinner ai-spinner--small"
        />
        {{ action }}
      </button>
      <button
        ref="cancel"
        type="button"
        class="ai-button is-small"
        @click="$emit('cancel')"
      >
        Отмена
      </button>
    </span>
  </span>
</template>

<script>
  export default {
    name: 'ConfirmInline',
    props: {
      text: { type: String, default: 'Удалить?' },
      action: { type: String, default: 'Удалить' },
      busy: { type: Boolean, default: false },
    },
    mounted() {
      // Focus inside (on the safe choice): Esc then cancels here instead of closing the assistant window.
      this.$nextTick(() => this.$refs.cancel && this.$refs.cancel.focus());
    },
  };
</script>

<style lang="scss" scoped>
  .ai-confirm {
    display: inline-flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: flex-end;
    gap: 6px 8px;
    min-width: 0;
  }

  .ai-confirm__text {
    color: var(--ui-text);
    font-size: 13px;
    overflow-wrap: anywhere;
  }

  .ai-confirm__buttons {
    display: inline-flex;
    gap: 6px;
  }
</style>
